export function convertHeightToInches(heightString: string): number {
    // Regex explanation:
    // ^\s* - Matches optional leading whitespace
    // (\d+)\s*(?:'|ft|feet)?\s* - Captures the first number as feet (optional units)
    // (?:(\d+)\s*(?:''|"|in|inches)?)? - Optionally captures the second number as inches (optional units)
    // \s*$ - Matches optional trailing whitespace
    const match = heightString.trim().match(/^(\d+)\s*(?:'|ft|feet)?\s*(?:(\d+)\s*(?:''|"|in|inches)?)?\s*$/i);

    if (!match) {
        console.error(`Invalid height format: ${heightString}`);
        return NaN;
    }

    // Group 1 is the first number found
    const val1 = parseInt(match[1], 10);
    // Group 2 is the second number found (if any)
    const val2 = parseInt(match[2], 10);

    // Determine if the input was only inches or feet and inches
    if (match[2] === undefined) {
        // If only one number was provided, assume it's total inches if no feet/inch symbols are present,
        // otherwise it's likely just feet. A robust solution might need more context or stricter input.
        // For "5' 10\"", val1 is 5, val2 is 10.
        // For "70\"", val1 is 70, val2 is undefined.
        // For "6", val1 is 6, val2 is undefined.

        // A simpler approach is to use the captured groups directly as intended by the regex structure above
        const feet = val1;
        const inches = 0; // If only one number matched the first group pattern, assume 0 inches for '5ft'

        return feet * 12 + inches;
    } else {
        const feet = val1;
        const inches = val2;
        return feet * 12 + inches;
    }
}
